import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Mail, X } from 'lucide-react';
import { useState } from 'react';
/**
 * Self-contained email chips editor (type + Add / Enter, click X to remove).
 * Normalizes to lowercase, rejects invalid addresses and duplicates. Used by
 * Settings > TC groups and the Submit Consultation dialog.
 */
export function EmailChipsInput({ emails, onChange, placeholder, addLabel, removeLabel, disabled = false, }) {
    const [input, setInput] = useState('');
    function addEmail() {
        const email = input.trim().toLowerCase();
        if (!email)
            return;
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
            return;
        if (emails.includes(email))
            return;
        onChange([...emails, email]);
        setInput('');
    }
    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            addEmail();
        }
    }
    return (_jsxs("div", { children: [_jsxs("div", { className: "flex gap-2", children: [_jsx(Input, { type: "email", value: input, onChange: (e) => setInput(e.target.value), onKeyDown: handleKeyDown, placeholder: placeholder, disabled: disabled, className: "h-8 flex-1 text-sm" }), _jsx(Button, { type: "button", variant: "outline", size: "sm", onClick: addEmail, disabled: disabled || !input.trim(), className: "h-8 px-3", children: addLabel })] }), emails.length > 0 && (_jsx("div", { className: "mt-2 flex flex-wrap gap-1.5", children: emails.map((email) => (_jsxs("span", { className: "bg-muted text-foreground/80 inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs", children: [_jsx(Mail, { className: "text-muted-foreground h-3 w-3" }), email, !disabled && (
                        // A 24px target (it was 14px) that the negative margins keep
                        // from growing the chip; 32px where the pointer is a finger.
                        _jsx("button", { type: "button", "aria-label": removeLabel(email), onClick: () => onChange(emails.filter((e) => e !== email)), className: "hover:bg-destructive/20 hover:text-destructive -my-1 -mr-1.5 ml-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full transition-colors pointer-coarse:h-8 pointer-coarse:w-8", children: _jsx(X, { className: "h-2.5 w-2.5", "aria-hidden": true }) }))] }, email))) }))] }));
}
